import { max } from "date-fns";

export const tabsStataticsContryDetail = [
    { id: 'attacks', label: 'eventodeportivo_paises_Tab_texto_titulo_Ataques', maxCharacteres: 19 },
    { id: 'defenses', label: 'eventodeportivo_paises_Tab_texto_titulo_Defensas', maxCharacteres: 19 },
    { id: 'goalkeeper', label: 'eventodeportivo_paises_Tab_texto_titulo_Porteros', maxCharacteres: 19 }
]


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StatsBody/constants.js